module.exports = __webpack_public_path__ + "img/black-curve.2c2c3f47.svg";